import React from 'react';

import Icon from '@/components/common/icon';

export default [
  {
    label: 'adminapp_menu_partner_type',
    icon: <Icon name="handshake" className="iconRightMarginMid" />,
    items: [
      {
        label: 'adminapp_menu_partner_type_list',
        route: 'partner_types_list'
      },
      {
        label: 'adminapp_menu_partner_type_create',
        route: 'partner_types_create'
      }
    ]
  }
];
